import React from 'react'

const Footer = () => {
    return (
      <div className="d-block copyright py-4 text-center text-white">
      <div className="container">
        <small>Copyright ©&nbsp; <a href="https://articadev.com">Artica Dev 2021</a></small>
      </div>
    </div>
    )
}

export default Footer
